// extracted by mini-css-extract-plugin
export default {"Search":"TestQueueHeader_Search__8xoxQ"};